import { Timestamp } from '@griply/types';

import { parseDateKey } from './format-date-key';

// A calendar event's start, discriminated by which field is present: `date`
// ('yyyy-MM-dd', all-day) or `dateTime` (ISO instant, timed). Accepts both the
// `CalendarEventDateTime` (`?: never`) and `ExternalCalendarEvent` (`?: null`) start shapes.
export type CalendarEventStart = {
  date?: string | null;
  dateTime?: string | null;
};

// The local calendar day an occurrence represents. All-day starts are 'yyyy-MM-dd'
// strings — parse them LOCALLY (parseDateKey), never `new Date(string)` which reads
// them as UTC midnight and lands the day on the previous day in behind-UTC zones,
// shifting every day/week calculation (habit ring, check state, completion day).
export const getCalendarEventReferenceDate = (
  start: CalendarEventStart,
  fallback: Timestamp,
): Timestamp => {
  if (start.dateTime) {
    return new Date(start.dateTime);
  }

  if (!start.date) {
    return fallback;
  }

  return parseDateKey(start.date);
};
